import { combineReducers } from 'redux';
import configReducer from './configReducer';
import sessionReducer from './sessionReducer';
import actionReducer from './actionReducer';
import dataReducer from './dataReducer';

export default combineReducers({
  action: actionReducer,
  config: configReducer,
  session: sessionReducer,
  data: dataReducer,
});
